import { useMemo } from "react";

/**
 * Eine Kennungsliste mit STABILER Identität (Abschluss-Review K5): Solange sich ihr Inhalt nicht ändert, bleibt es
 * dasselbe Array. Als Abhängigkeit eines Effekts oder Rückrufs wirft eine neu gebaute, gleiche Liste (die Sicht der
 * Chips, die Unternehmen der Sitzung) so keinen Abruf erneut an — EINE Stelle statt eines Schlüssels `join(",")`
 * je Aufrufer, den der Effekt wieder auseinandernimmt. `undefined` bleibt `undefined`.
 */
export function useStabileListe<T extends readonly string[] | undefined>(liste: T): T {
  const schluessel = liste?.join(",");
  // Bewusst nur der Schlüssel als Abhängigkeit: Er IST der Inhalt (Kennungen tragen kein Komma).
  return useMemo(() => liste, [schluessel]);
}
